import type { FaireProductEntity } from "../../entity_types/product";

export const nyc_soap_4: FaireProductEntity = {
  token: "nyc-soap-4",
  type: "product",
  name: "Shea Butter Hand Cream",
  brandName: "Pure Skincare",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/609c7b136226be66209656e2a6f9abba1bf6ce8965f5baf509f9ba2d9f7446a9.jpeg",
  priceDollars: 20,
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.prerelease.faire.dev/fastly/609c7b136226be66209656e2a6f9abba1bf6ce8965f5baf509f9ba2d9f7446a9.jpeg",
  weight: 0.9,
  dimensions: {
    width: 3,
    height: 6,
    depth: 2,
  },
  description: "Organic body lotion from Williamsburg",
  categoryTokens: ["cat_bath-all"],
  tags: ["nyc-local", "premium", "organic", "brooklyn"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-compass-migration",
  },
};
